import Usage from './Usage.container';

export default Usage;
